import React from "react";

export default function EmailLogs() {
  return (<div>Logs</div>)
}